import React, { startTransition } from "react";
import logo from "../../assets/icons/logo.svg";
import classes from "../../styles/TermsAndPrivacy.module.scss";
import CustomImage from "../../components/core/CustomImage/CustomImage";
import { useNavigate } from "react-router";
import { APP_PATH } from "../../routes/route";
import classNames from "classnames";

function PrivacyPolicy() {
  const navigate = useNavigate();
  const handleClick = () => {
    startTransition(() => {
      navigate(`${APP_PATH}`);
    });
  };
  return (
    <>
      <div className={classes.header}>
        <CustomImage
          src={logo}
          clickHandler={handleClick}
          height={20}
          className={classes.logo}
        />
        <div className={classes.heading}>Our Privacy Policy</div>
      </div>

      <div className={classNames(classes.container, "containerWidth")}>
        <div className={classes.content}>
          Our Privacy Policy outlines how we gather, receive, store, process,
          disclose, transfer, manage, and handle your personal information
          concerning your usage of our Product and our websites, specifically
          Data Collected by the Company <b>Paytm Cloud Solution</b>.<br></br>
          <br></br>
          Please note that this Privacy Policy is subject to periodic revisions.
          In the event of any modifications to this Policy, we will notify you
          through email, pop - up notifications, or alternative communication
          methods. Additionally, these updates will be published on our
          Websites.
        </div>
        <div className={classes.innerHeading}>
          Data Collected by the Company
        </div>
        <div className={classes.content}>
          We cover two categories in our Privacy Policy, namely, personally
          identifiable information (PII) and non-personally identifiable
          information (NPII). PII includes information which can be used,
          directly or indirectly, to identify, contact or locate your Authorized
          User(s) using the Product or your end-users. NPII includes your and
          your Authorized User(s)’ IP address, cookies, third party’s cookies,
          backend logs that our techies have access to and web pages that have
          been viewed by you through your Authorized Users and employees. Note:
          PII and NPII will collectively be referred to as the Information.
        </div>
        <div className={classes.innerHeading}>Aim and Usage</div>
        <div className={classes.content}>
          We will collect Authorized User(s) Information for certain purposes,
          such as:
          <ul>
            <li>
              We will collect Authorized User(s) Information for certain
              purposes, such as: To allow and allow Authorized User(s) to use
              our Product.
            </li>
            <li>
              Granting Authorized User(s) access to our Websites and Product and
              services from third parties.
            </li>
            <li>
              Understanding Authorized User(s) use of our Website and Product
              for improved overall use.
            </li>
            <li>
              Provisioning of real time notifications through SMS and/or e-mail
              regarding missed calls.
            </li>
            <li>
              Call analytics such as understanding the manner in which your
              business functions, provision of training and analyzing call
              patterns and call reporting, agent productivity, team efficiency
              etc
            </li>
            <li>
              Provisioning of actionable insights in the form of details of key
              metrics to understand Authorized User(s)’ customer behavior.
            </li>
            <li>
              Provisioning of access to Customer Data through the customer
              relationship management tool.
            </li>
            <li>
              Provisioning of call making facility from a browser extension
              provided by us.
            </li>
            <li>
              Improvement of the functionality of our Website and Product either
              directly or through a third party
            </li>
          </ul>
        </div>
        <div className={classes.innerHeading}>Cookies Usage</div>
        <div className={classes.content}>
          We may also use cookies for implementing and using display
          advertising. We use cookies while providing access to our Product.
          Authorized User(s) may opt out of Google analytics for display
          advertising and customize Google display network ads using the ads
          preferences manager.
          <br></br>
          <br></br>
          Moreover, we and our third party vendors may use first party cookies
          such as the ‘Google analytics cookie’ and third party cookies such as
          the ‘DoubleClick cookie’ together to inform, optimize and serve ads
          based on your and/or others’ visits to the Website
        </div>
        <div className={classes.innerHeading}>Third Party Website Access</div>
        <div className={classes.content}>
          You should understand and agree that when you use the Product, there
          may be certain links which may direct Authorized User(s) to another
          website (Third Party Website). We urge Authorized User(s) to
          familiarize itself with policies of every such Third Party Website.
        </div>
        <div className={classes.innerHeading}>Our Oath</div>
        <div className={classes.content}>
          We pledge that we will not trade, distribute, rent or sell any
          Information, provided by Authorized User(s) to any third party, except
          as provided in our Privacy Policy or through any other instruction
          issued by you.
        </div>
        <div className={classes.innerHeading}>Consent</div>
        <div className={classes.content}>
          You allow us to receive, store, collect, deal and handle Authorized
          User(s) and end-user’s Information in accordance with this Privacy
          Policy by visiting our Websites, using our Product as a trial user or
          as a paid subscriber.
        </div>
        <div className={classes.innerHeading}>Withdrawal of Consent</div>
        <div className={classes.content}>
          If you wish to withdraw consent to our Privacy Policy, you may contact
          us on <a href="mailto:et.support@paytm.com">et.support@paytm.com</a>
          <br></br>
          Upon withdrawal of your consent to our Privacy Policy, your
          Information will be deleted as soon as reasonably possible in
          accordance with applicable policies and laws.
          <br></br>
          Also, we reserve the right to terminate your use of the Product after
          withdrawal from the consent policy.
          <br></br>
          This Privacy Policy comes into effect from{" "}
          <b style={{ color: "red" }}>Live Date</b> If at any time, you have
          questions or concerns about our Privacy Policy, please feel free to
          reach out to us at{" "}
          <a href="mailto:et.support@paytm.com">et.support@paytm.com</a>
        </div>
      </div>
    </>
  );
}
export default PrivacyPolicy;
